<template>
  <v-container class="fill-height justify-center align-center">
    You have been logged out, click&nbsp;<a href="#" @click.prevent="goToLogin"
      >here</a
    >&nbsp;to login again
  </v-container>
</template>

<script lang="ts" setup>
  // import composable
  import { useAuthStore } from '@/store/auth/authStore';
  import { onMounted } from 'vue';
  import { useRouter } from 'vue-router';
  import Routes from '@/enums/Routes';


  const router = useRouter();
  const authStore = useAuthStore();

  const goToLogin = () => {
    router.push(Routes.LOGIN);
  };

  onMounted(() => {
    authStore.logOutUser();
    goToLogin();
  });
</script>
